<script>
import BankListDesktopView from "./BankListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders BankListDesktopView using the parent bank-list instance as
 * context so template bindings and $refs stay on bankList.vue (provide/inject).
 */
export default {
  name: "BankListDesktopBridge",
  inject: ["bankList"],
  render() {
    const bankList = this.bankList;
    const viewOptions = BankListDesktopView.options || BankListDesktopView;
    const render = viewOptions.render;

    if (!bankList || typeof render !== "function") {
      return null;
    }

    const options = bankList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(bankList, bankList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
